<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Charity Redeemed Report</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <b>{{ lps() }}</b>
      /
      <router-link to="/lps/charity">Charity</router-link>
      /
      <b>Details</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div class="row mb-4">
      <div class="col-lg-12 col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title">
              <button class="btn btn-primary" @click="print">Print</button>
            </div>
            <div id="printGraph">
              <div class="card-title text-center">
                  <h2>Charity Demographic</h2>
              </div>
              <div class="row">
                <div class="col-7">
                  <span v-if="!check">
                    No Data Available
                  </span>
                  <GChart
                    v-else
                    type="PieChart"
                    :data="chart"
                    :options="pieOptions"
                  />
                </div>

                <div class="col-5 text-left">
                  <b style="font-size: 15px">
                    <label>Total Unpaid: $ {{total_unpaid}}</label>
                    <br>
                    <label>Total Paid: $ {{total_paid}}</label>
                    <br>
                    <label>Total: $ {{total}}</label>
                  </b>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Card -->
        <div class="card text-left">
          <div class="card-body">
            <div id="active" class="">
              <h4 class="card-title mb-3">
                <b>{{ title }}</b>
              </h4>
              <!-- Active -->
              <div class="table-responsive">
                  <div class="text-right">
                    <input
                      type="button"
                      to="/"
                      class="btn btn-success btn-rounded col-md-1"
                      value="Pay"
                      @click="redirectToPayment()"
                    />
                  </div>
                </div>
                <table
                  id="payout_tbl"
                  class="display table table-striped table-bordered"
                  style="width:100%; text-align: center;"
                >
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Month</th>
                      <th>Year</th>
                      <th>Total earn</th>
                      <th>Invoice</th>
                      <th>Status</th>
                      <th>Payment Vouchers</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(list, index) in lists" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ convertMonth(list.month) }}</td>
                      <td>{{ list.year }}</td>
                      <td>$ {{ list.total }}</td>
                      <td>{{ checkInvoice(list.invoice_url) }}</td>
                      <td>{{ checkCashed(list.cashed) }}</td>
                      <td>{{ list.payment_voucher ? list.payment_voucher : '-' }}</td>
                      <td>
                        <input type="checkbox" v-model='payout_ids' :value='list.id' :id='"checkbox_" + list.id' :disabled='list.cashed == 1'>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { GChart } from "vue-google-charts";

export default {
  components: {
    GChart
  },

  data() {
    return {
      lists: [],
      payout_ids: [],

      columnData: [],
      chart: [],
      check: "",

      pieOptions: {
        // title: "Charity Demographic",
        pieHole: 0.5,
        height: 500,
        legend: "bottom"
      },

      total_unpaid: 0,
      total_paid: 0,
      total: 0,
    };
  },

  methods: {
    //print graph
    print() {
      // Pass the element id here
      this.$htmlToPaper("printGraph");
    },

    async loadDetails() {
      if (this.checkToken() == false) {
        swal({
          icon: "error",
          text: "You are not authorised"
        });
        return;
      }

      try {
        let id = this.$route.params.id;
        let result = await axios.get(
          axios.lpsURL + "/payout/charity/report/" + id,
          {
            headers: {
              Authorization: "Bearer " + this.checkToken()
            }
          }
        );
        this.lists = result.data.payouts;

      } catch (error) {
        console.log(error);
      }
    },

    async loadGraph() {
      let id = this.$route.params.id;
      // check if has token
      if (!this.checkToken()) {
        return;
      }
      try {
        let result = await axios.get(
          axios.lpsURL + "/payout/charity/demographic?entity_id=" + id,
          {
            headers: {
              Authorization: "Bearer " + this.checkToken()
            }
          }
        );
        this.chart = result.data.Pie_Chart;
        this.total_unpaid = result.data.total_unpaid;
        this.total_paid = result.data.total_paid;
        this.total = result.data.total;
        if (this.chart[1][1] == 0 && this.chart[2][1] == 0) {
          this.check = false;
          return;
        }
        this.check = true;
      } catch (error) {
        console.log(error);
      }
    },

    checkToken() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token === null) {
        return false;
      }

      token = JSON.parse(token);
      token = token.access_token;
      return token;
    },

    convertMonth(int) {
      switch (int) {
        case 1:
          return "January";
        case 2:
          return "February";
        case 3:
          return "March";
        case 4:
          return "April";
        case 5:
          return "May";
        case 6:
          return "June";
        case 7:
          return "July";
        case 8:
          return "August";
        case 9:
          return "September";
        case 10:
          return "October";
        case 11:
          return "November";
        case 12:
          return "December";
      }
    },

    checkInvoice(str) {
      if (str == null) {
        return "N/A";
      }
      return "Completed";
    },

    checkCashed(str) {
      if (str == 0) {
        return "Unpaid";
      }
      return "Paid";
    },

    redirectToPayment() {
      if(this.payout_ids.length == 0) {
        swal({
          icon: 'error',
          text: 'Please select payouts to pay'
        })

        return
      }
      localStorage.setItem('payout_ids', JSON.stringify(this.payout_ids))
      this.$router.push("/lps/charity/payment");
    },

    viewInvoice(id) {
      if (!this.checkToken()) {
        return;
      }
      axios
        .get(axios.lpsURL + "/payout/download/" + id, {
          headers: {
            Authorization: "Bearer " + this.checkToken()
          },
          responseType: "arraybuffer"
        })
        .then(res => {
          let type = "application/pdf";
          let blob = new Blob([res.data], { type: type }),
            url = window.URL.createObjectURL(blob);
          window.open(url);
        });
    },

    redirect(id, month1, year) {
      let months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ];
      let month = months.indexOf(month1) + 1;

      return "/report/view/" + id + "/" + month1 + "/" + year;
    },

    destroyDatatable() {
      $("#payout_tbl")
        .DataTable()
        .destroy();
    },

    createDatatable() {
      $("#payout_tbl").DataTable({
        pageLength: 5,
        dom: "Bfrtip",
        buttons: ["excel", "pdf"]
      });
    },
    lps() {
      return this.$lps()
    }
  },

  async created() {
    await this.loadGraph();
    await this.loadDetails();
    this.createDatatable();
  }
};
</script>
